import { DIRECTIONS } from './constants';

export interface DataItem {
    [key: string]: any;
}

export interface SortOptions {
    columnId: string;
    direction: (typeof DIRECTIONS)[keyof typeof DIRECTIONS];
}

export type Option = string | number | boolean | null | undefined | any | 'none';

export interface Filters {
    [key: string]: SortOptions | Option | Option[];
    pageNumber: number;
    pageSize: number;
    sorted?: SortOptions | null;
}

export interface FilterConfig {
    [key: string]: (value: any) => string;
}

export enum RoleName {
    PLATFORM_ADMIN = 'PlatformAdmin',
    TENANT_ADMIN = 'TenantAdmin',
    USER = 'PortalUser',
}
